import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';

export default grapesjs.plugins.add('gjs-calendar', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'calendar',
    blocks: ['calendar'],
    defaultStyle: true,
    label: 'Calendar',
    category: 'Advanced',
    type: 'calendar',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadTraits(editor, options);
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
